import script from "./TokenPreviewSection.vue?vue&type=script&setup=true&lang=js"
export * from "./TokenPreviewSection.vue?vue&type=script&setup=true&lang=js"

import "./TokenPreviewSection.vue?vue&type=style&index=0&id=7be08320&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7be08320"]])

export default __exports__